import { MatDialogRef } from '@angular/material/dialog';
import { ExportDialogComponent } from '../../ui-kit';
import { ExportType } from '../../store';

export interface ExportFileFacade {
  startExportToFile(
    reportName: string,
    dialogRef: MatDialogRef<ExportDialogComponent>,
    navigationNeeded: boolean,
    addressExport?: string,
    reportType?: ExportType,
  ): void;
}
